import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useGet } from "../api/useApi";
import { API_ROUTES } from "../api/apiRoutes";
import { useDebounce, buildQueryParams } from "../utils/pageHelpers";
import { IconX, IconSearch } from "./Icons";
import WatchImg from "./WatchImg";

const SearchOverlay = ({ onClose }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 1000);
  const lastExecutedDeps = useRef(true); // Track what the dependencies were when we last executed

  const {
    data: searchedProducts,
    loading: loadingGetSearchProducts,
    execute: getSearchProducts,
  } = useGet(API_ROUTES.WATCHES.GET_ALL, {
    onError: (error) => {
      console.error("Error fetching search products:", error);
    },
  });

  useEffect(() => {
    const currentDeps = JSON.stringify({
      debouncedSearch,
    });

    // Skip if we've already executed with these exact values
    if (
      lastExecutedDeps.current !== null &&
      lastExecutedDeps.current === currentDeps
    ) {
      return;
    }

    lastExecutedDeps.current = currentDeps;

    if (debouncedSearch !== "") {
      getSearchProducts({
        query: buildQueryParams({
          sort: "id%desc",
          search: debouncedSearch,
        }),
      });
    }
  }, [debouncedSearch]);

  const handleSelect = (watch) => {
    onClose();
    navigate(`/watches/${watch?.id}`);
  };

  return (
    <div className="search-overlay">
      <button className="search-close" onClick={onClose}>
        <IconX />
      </button>
      <div className="search-input-wrap">
        <IconSearch />
        <input
          autoFocus
          placeholder="Search watches..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="search-results">
        {debouncedSearch !== "" && loadingGetSearchProducts && (
          <div className="spinner-container--sm">
            <div className="spinner spinner--sm" />
          </div>
        )}
        {!loadingGetSearchProducts &&
          debouncedSearch !== "" &&
          searchedProducts?.value?.map((w) => (
            <div
              key={w.id}
              className="search-result"
              onClick={() => handleSelect(w)}
            >
              <WatchImg
                className="search-result-img"
                src={w?.product_images?.[0]?.file_url}
                alt={w?.name}
              />

              <div>
                <div className="search-result-brand">{w?.brand?.name}</div>
                <div className="search-result-name">
                  {w?.model?.name} - {w?.name}
                </div>
                {w?.is_show_price ? (
                  <div className="search-result-price">
                    Rp {w?.selling_price?.toLocaleString("id-ID")}
                  </div>
                ) : (
                  <div className="search-result-price search-result-ask-price">
                    Ask for Price
                  </div>
                )}
              </div>
            </div>
          ))}
        {!loadingGetSearchProducts && searchedProducts?.value?.length === 0 && (
          <div className="empty-state-message">
            No watches found for "{debouncedSearch}"
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchOverlay;
